import React, { useEffect, useState } from "react";
import { usePhrase, useLang } from "@/contexts/LanguageContext";
import { api, formatINR } from "@/lib/api";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";

const COLORS = ["#0f172a", "#ea580c", "#10b981", "#0ea5e9", "#a855f7", "#f59e0b", "#ef4444", "#14b8a6"];

export default function GovSector() {
  const pt = usePhrase();
  const { tv } = useLang();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/sector-demand").then((r) => setRows((r.data || []).filter((d) => d.sector))).catch(() => {}); }, []);
  const data = rows.map((r) => ({ ...r, sector: tv(r.sector) }));
  return (
    <div className="space-y-6" data-testid="gov-sector">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{pt("Sector Analysis")}</h1></div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="p-6 rounded-lg border border-slate-200 bg-white">
          <h2 className="font-semibold text-slate-900 brand-heading mb-3">{pt("Sector-wise demand (count)")}</h2>
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie data={data} dataKey="count" nameKey="sector" outerRadius={110} label>
                {data.map((r, i) => <Cell key={r.sector || `sector-${i}`} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="p-6 rounded-lg border border-slate-200 bg-white">
          <h2 className="font-semibold text-slate-900 brand-heading mb-3">{pt("Sector demand (₹ amount)")}</h2>
          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={data} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis type="number" tick={{ fontSize: 10 }} tickFormatter={(v) => formatINR(v)} />
              <YAxis type="category" dataKey="sector" width={140} tick={{ fontSize: 10 }} />
              <Tooltip formatter={(v) => [formatINR(v), pt("Sector demand (₹ amount)")]} />
              <Bar dataKey="total_amount" fill="#0f172a" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
